/**
 * Stores build information. The string literals are replaced at compile time by `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2024-09-25",
    versionChannel: "nightly",
    buildDate: "2024-09-25T00:06:08.761Z",
    commitHash: "3da016638a4b0ea3ac5d72cdb7e422b2bb54b85f",
};
